import { z } from 'zod';
import { expectType, zDocument } from './model.js';
export const zStarredBusiness = zDocument.extend({
    type: z.literal('starredBusiness'),
    businessId: z.string(),
    users: z.array(z.string()),
    totalStars: z.number()
});
expectType({});
expectType({});
export const EmptyStarredBusiness = {
    type: 'starredBusiness',
    _id: '',
    _rev: '',
    created: '',
    updated: '',
    businessId: '',
    users: [],
    totalStars: 0
};
